import { takeLatest } from 'redux-saga/effects';
import { GET_EARLIEST_DELIVERY_OPTIONS } from '../../actions/actionTypes';
import earliestDeliveryByZipCode from './earliestDeliveryByZipCode';

export default function* earliestDeliverySaga() {
  // eslint-disable-next-line no-console
  yield takeLatest(GET_EARLIEST_DELIVERY_OPTIONS, earliestDeliveryByZipCode);
}
